import Vue from "vue";
import Sticky from "vue-sticky-directive";

Vue.use(Sticky);

export default {};
